import { useState, useEffect } from "react";
import axios from "axios";
import { service_url, cookieValue } from "rest/const";
import { URLJoin } from "rest/const";

export function RestGetSync(route_path) {
  const [response, setPosts] = useState([]);

  let full_url = URLJoin(service_url, route_path);

  const config = {
    headers: {
      cookie: cookieValue,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    axios
      .get(full_url, config)
      .then((response) => {
        setPosts(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return response;
}
